import React from "react"
// import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
// import ReactPlayer from "react-player/lazy"
// import Modal from "react-modal"
import { Icon } from "react-icons-kit"
import { playCircle } from "react-icons-kit/fa/playCircle"
// import Image from "../../../template/common/src/components/Image"
// import Button from "../../../template/common/src/components/Button"
import Container from "../../../template/common/src/components/UI/Container"
import BannerWrapper, {
  BannerContent,
  BannerImage,
  BannerImageForMobile,
  BannerHeading,
  BannerText,
  ButtonGroup,
} from "./banner.style"
import { useTheme } from "../../../context/ThemeContext"
// import { ModalStyles } from "../../../template/containers/Navbar/navbar.style"
// import MailroomBanner from "../../../images/mailroom-banner-hero-image.png"
// import MailroomBannerForMobile from "../../../images/mailroom-mobile-hero-image.png"
// import MailroomBannerForMobileSE from "../../../images/mailroom-mobile-hero-image-se.png"
// import MailroomBannerForMobilePhone from "../../../images/mailroom-mobile-hero-image-phone.png"
// import MailroomBannerForMobilePhablet from "../../../images/mailroom-mobile-hero-image-phablet.png"
// import MailroomBannerTablet from "../../../images/mailroom-banner-hero-image-tablet.png"
// import MailroomBannerDesktop from "../../../images/mailroom-banner-hero-image-desktop.png"
// import MailroomBannerLargeDesktop from "../../../images/mailroom-banner-hero-image-largeDesktop.png"


import { mailroomAccentColor } from "../../../theme"
// const customStyles = {
//   content: {
//     top: "50%",
//     left: "50%",
//     right: "auto",
//     bottom: "auto",
//     marginRight: "-50%",
//     transform: "translate(-50%, -50%)",
//     overflow: "hidden",
//     zIndex: 50,
//   },
//   overlay: {
//     backgroundColor: "rgba(255, 255, 255, 0.95)",
//     zIndex: 80,
//   },
// }


const Button = React.lazy(() =>
  import(
    "../../../template/common/src/components/Button"
  )
)

const Banner = ({ showModal, setMainSelectedPlan }) => {
  const theme = useTheme()
  // const [modalIsOpen, setIsOpen] = useState(false)
  // const [modalContent, setModalContent] = useState("")

  // function openModal() {
  //   setIsOpen(true)
  //   const ReactPlayer = React.lazy(() => import('react-player/lazy'));
  //   const Modal = React.lazy(() => import('react-modal'));
  //   setModalContent(
  //     <React.Suspense fallback={<div>loading</div>}>
  //       <ReactPlayer
  //         url="https://www.youtube.com/watch?v=PYdNNNa1snc&ab_channel=PackageX/"
  //         playing={setIsOpen}
  //         width="100%"
  //         height="100%"
  //       />
  //     </React.Suspense>
  //   )
  // }

  // function afterOpenModal() {
  //   // references are now sync'd and can be accessed.
  // }

  // function closeModal() {
  //   setIsOpen(false)
  // }

  const setMainSelectedPlanner = planType => {
    setMainSelectedPlan(planType)
    showModal(true)
  }

  // if (modalIsOpen) {

  //   const ReactPlayer = React.lazy(() => import('react-player/lazy'));
  //   const Modal = React.lazy(() => import('react-modal'));
  //   setModalContent(<React.Suspense fallback={<div>loading</div>}>
  //     <Modal
  //       isOpen={modalIsOpen}
  //       onAfterOpen={afterOpenModal}
  //       onRequestClose={closeModal}
  //       style={customStyles}
  //       contentLabel="Watch Video Modal"
  //     >
  //       <React.Suspense fallback={<div>loading</div>}>
  //         <ReactPlayer
  //           url="https://www.youtube.com/watch?v=PYdNNNa1snc&ab_channel=PackageX/"
  //           playing={setIsOpen}
  //           width="100%"
  //           height="100%"
  //         />
  //       </React.Suspense>
  //       <Button
  //         className="modalCloseBtn"
  //         variant="fab"
  //         onClick={closeModal}
  //         icon={<i className="flaticon-plus-symbol" />}
  //       />
  //     </Modal>
  //   </React.Suspense>
  //   )

  // }

  const isSSR = typeof window === "undefined"

  return (
    <>
      {/* <ModalStyles /> */}
      <BannerWrapper
        id="home"
        backgroundColor="#F4F8FB"
        border="1px solid rgba(3,24,49,0.05)"
      >
        <Container>
          <BannerContent>
            <BannerHeading as='h1'>
            The Mailroom Management Software to Accelerate Your Business Growth
            </BannerHeading>
            <BannerText>
            Mailroom helps you keep your deliveries in place with its OCR-enabled app. You can scan deliveries and notify the recipients within a few seconds. Enjoy the convenience and save operational costs with a digital mailroom.  
            </BannerText>
            <ButtonGroup>
              {/* <Link to="/mailroom/signup/gold/"> */}
              {!isSSR && (
                <React.Suspense fallback={<div />}>
                  <Button
                    className="primary"
                    backgroundColor={mailroomAccentColor}
                    color="#fff"
                    shadowColor="#027AFF"
                    title="Try for Free"
                    gapRight
                    isGroup={true}
                    // onClick={showModal}
                    onClick={() => setMainSelectedPlanner("Basic")}
                  />
                  {/* </Link> */}
                  <Button
                    className="text"
                    variant="textButton"
                    title="Watch Video"
                    icon={<Icon icon={playCircle} />}
                    iconPosition="right"
                    onClick={theme.openVideoModal}
                  />
                </React.Suspense>
              )}
            </ButtonGroup>
          </BannerContent>
          <BannerImage>
            {/* <Image
            //  srcSet={`${MailroomBannerTablet} 350w, ${MailroomBannerDesktop} 400w, ${MailroomBanner} 5302w,  ${MailroomBanner} 3296w`}
           //   sizes="(max-width: 991px) 350px,(max-width: 1200px) 400px, (max-width: 1400px) 530px"
              src={MailroomBanner}
              heigh="100%"
              alt="Mailroom Hero Image"
              title=""
            /> */}
            <StaticImage
              src="../../../images/mailroom-banner-hero-image.png"
              alt="mailroom management software"
              placeholder="blurred"
              loading="eager"
            />
          </BannerImage>
          <BannerImageForMobile>
            {/* <Image
              srcSet={`${MailroomBannerForMobileSE} 250w,${MailroomBannerForMobilePhablet} 270w,${MailroomBannerForMobilePhone} 240w`}
              sizes="(max-width: 375px) 250px,(max-width: 650px) 240px, (max-width: 768px) 270px"
              heigh="100%"
              alt="Mailroom Hero Image"
              title=""
            /> */}
            <StaticImage
              src="../../../images/mailroom-mobile-hero-image.png"
              alt="Mailroom Hero Image"
              placeholder="blurred"
              loading="eager"
            />
          </BannerImageForMobile>
        </Container>
      </BannerWrapper>
    </>
  )
}

export default Banner
